import { ColorReference } from './color.js';
import { Length } from './length.js';
export const GradientColorStop = (props) => ({
    color: ColorReference(props.color),
    start: props.start != null ? Length(props.start) : null,
    end: props.end != null ? Length(props.end) : null
});
export const Gradient = (gradient) => {
    let angle = 0;
    let stops = [];
    if (!gradient) {
        return { angle, stops };
    }
    if (gradient.angle) {
        angle = gradient.angle;
    }
    if (Array.isArray(gradient.stops)) {
        stops = gradient.stops.map(GradientColorStop);
    }
    return { angle, stops };
};
Gradient.isValid = (gradient) => gradient.stops.length > 0 && gradient.stops.every((stop) => ColorReference.isValid(stop.color));
//# sourceMappingURL=gradient.js.map